import { ROUTE_NAMES } from '~/constants/routes';

export default defineNuxtRouteMiddleware(to => {
    const routeBaseName = useRouteBaseName();
    const { isOnboardingInProgress } = useOnboarding();
    const { openOnboardingModal } = useModals();

    if (isOnboardingInProgress.value && import.meta.client) {
        openOnboardingModal();
    } else if (routeBaseName(to) === ROUTE_NAMES.SIGNUP_ONBOARDING) {
        return navigateTo({ name: 'index' });
    }
});
